<mat-icon
  svgIcon="arrow-paginator-active"
  class="rotated-counter-clockwise"
  (click)="addMonth(-1)"
>
</mat-icon>
<div class="date">{{ periodLabel }}</div>
<mat-icon svgIcon="arrow-paginator-active" (click)="addMonth(1)"></mat-icon>
